import React from 'react';

export const PointInstructions = () => (
  <div className="instructions-container">
    <p className="text-muted small" style={{ lineHeight: 1.2 }}>
      To manually edit the location, click and drag the marker to a new
      position. (You will need to save!)
    </p>
  </div>
);

export const PolyInstructions = () => (
  <div className="instructions-container">
    <p className="text-muted small" style={{ lineHeight: 1.2 }}>
      Update the overlay position by dragging the image.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Instructions/index.js